<template>
    <div class="animated fadeIn inventory-page">
        <b-row>
            <b-col>
                <transition name="fade">
                    <b-card class="card-wrap inventory-card">
                        <component-new-header
                            title="Item Details"
                            :hasSearch="false"
                            :hasReload="false"
                            :hasRadio="false"
                            :hasCreate="false"
                            :hasback="false"
                        />

                        <!-- Filter Row -->
                        <div class="filter-section">
                            <b-row class="align-items-center">
                                <b-col cols="12" md="5" class="mb-3 mb-md-0">
                                    <label class="filter-label"
                                        >Warehouse</label
                                    >
                                    <eb-select
                                        type="text"
                                        :options="stockOptions"
                                        label="label"
                                        placeholder="Select Warehouse"
                                        @input="changeStockpoint"
                                        class="filter-select"
                                    ></eb-select>
                                </b-col>
                                <b-col cols="12" md="5" class="mb-3 mb-md-0">
                                    <label class="filter-label">Item</label>
                                    <eb-select
                                        type="text"
                                        :options="itemList"
                                        label="label"
                                        placeholder="Select Item"
                                        @input="changeItem"
                                        class="filter-select"
                                    ></eb-select>
                                </b-col>
                                <b-col
                                    cols="12"
                                    md="2"
                                    class="d-flex align-items-end p-0"
                                >
                                    <b-button
                                        variant="primary"
                                        block
                                        @click="getStockStatus"
                                        :disabled="!itemId || itemId === ''"
                                        class="go-btn"
                                    >
                                        <span>GO</span>
                                    </b-button>
                                </b-col>
                            </b-row>
                        </div>

                        <!-- Stock Summary Cards (Mobile-friendly) -->
                        <div v-if="stocksData.length > 0" class="mt-4">
                            <!-- Mobile Card View -->
                            <div class="d-block d-md-none">
                                <div
                                    v-for="(item, index) in paginatedData"
                                    :key="index"
                                    class="mobile-stock-card mb-3"
                                >
                                    <div class="mobile-card-header">
                                        {{ item["ITEM NAME"] }}
                                    </div>
                                    <div class="mobile-card-body">
                                        <div class="stat-row">
                                            <span class="stat-label"
                                                >Total Stock</span
                                            >
                                            <span class="stat-value total">{{
                                                item["TOTAL STOCK"]
                                            }}</span>
                                        </div>
                                        <div class="stat-row">
                                            <span class="stat-label"
                                                >Available</span
                                            >
                                            <span
                                                class="stat-value available"
                                                >{{
                                                    item["AVAILABLE"] || 0
                                                }}</span
                                            >
                                        </div>
                                        <div class="stat-row">
                                            <span class="stat-label"
                                                >Booked</span
                                            >
                                            <span class="stat-value booked">{{
                                                item["BOOKED"] || 0
                                            }}</span>
                                        </div>
                                        <div class="stat-row">
                                            <span class="stat-label"
                                                >Delivered</span
                                            >
                                            <span
                                                class="stat-value delivered"
                                                >{{
                                                    item["DELIVERED"] || 0
                                                }}</span
                                            >
                                        </div>
                                        <div class="stat-row">
                                            <span class="stat-label"
                                                >Returned</span
                                            >
                                            <span class="stat-value returned">{{
                                                item["RETURNED"] || 0
                                            }}</span>
                                        </div>
                                        <div class="stat-row">
                                            <span class="stat-label"
                                                >Expired</span
                                            >
                                            <span class="stat-value expired">{{
                                                item["EXPIRED"] || 0
                                            }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Desktop Table View -->
                            <div class="d-none d-md-block table-responsive">
                                <b-table
                                    :dark="false"
                                    :hover="true"
                                    :striped="striped"
                                    :bordered="bordered"
                                    :small="small"
                                    :fixed="fixed"
                                    :items="stocksData"
                                    responsive="sm"
                                    id="my-table"
                                    :current-page="currentPage"
                                    :per-page="perPage"
                                    thead-class="table-header"
                                    class="inventory-table mt-2"
                                    :fields="Columns"
                                ></b-table>
                            </div>

                            <!-- Pagination + Download -->
                            <div class="bottom-bar mt-3">
                                <b-pagination
                                    v-if="stocksData.length > perPage"
                                    v-model="currentPage"
                                    :total-rows="stocksData.length"
                                    :per-page="perPage"
                                    class="mb-0 custom-pagination"
                                    size="sm"
                                ></b-pagination>
                                <div class="ml-auto">
                                    <b-button
                                        variant="primary"
                                        @click="downloadStock"
                                        class="download-btn"
                                    >
                                        <i class="fa fa-download mr-2"></i>
                                        Download
                                    </b-button>
                                </div>
                            </div>
                        </div>

                        <!-- Empty State -->
                        <div v-else class="empty-state">
                            <div class="empty-icon">📦</div>
                            <p class="empty-text">
                                Select a warehouse and item, then click
                                <strong>GO</strong> to view stock details.
                            </p>
                        </div>
                    </b-card>
                </transition>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import { Vue, Component, Prop } from "vue-property-decorator";
import { mapActions } from "vuex";
import ebSelect from "@/components/FormElements/Select";
import loader from "@/components/loader/nipigeloader.vue";
import { getPartnerParentData } from "@/services/partner";
import componentNewHeader from "@/components/componentNewHeader";
export default {
    name: "LoadInventory",
    components: {
        ebSelect,
        loader,
        componentNewHeader,
    },
    data: () => {
        return {
            perPage: 10,
            striped: false,
            bordered: true,
            small: false,
            fixed: false,
            currentPage: 1,
            loading: false,
            itemId: "",
            selectedItem: {},
            items: "",
            stockPointId: "",
            stocksData: [],
            Columns: [
                { key: "ITEM NAME", thClass: "col-item-name" },
                { key: "TOTAL STOCK" },
                { key: "BOOKED" },
                { key: "AVAILABLE" },
                { key: "DELIVERED" },
                { key: "RETURNED" },
                { key: "EXPIRED" },
            ],
        };
    },
    computed: {
        paginatedData() {
            const start = (this.currentPage - 1) * this.perPage;
            return this.stocksData.slice(start, start + this.perPage);
        },
        stockOptions() {
            let data = this.$store.getters["partner/GetAllStockPointList"];
            let userId = this.$store.getters["auth/getUserID"];
            if (data.length > 0) {
                return data.map((obj) => ({
                    _id: obj._id,
                    providerId: userId,
                    label: obj.office?.officeName || "",
                }));
            }
            return [];
        },
        itemList() {
            let data = this.$store.getters["item/GetItemListByCatalog"];
            if (data.length > 0) {
                let items = data.map((obj) => ({
                    _id: obj._id,
                    label: obj.description_summary,
                }));
                items.unshift({ label: "All", _id: "all" });
                return items;
            }
            return [];
        },
        userRole() {
            return (
                this.$store.getters["auth/getUserRole"] ||
                JSON.parse(sessionStorage.getItem("userLogin"))["role"]
            );
        },
        userCategory() {
            return JSON.parse(sessionStorage.getItem("userLogin"))["category"];
        },
    },
    methods: {
        ...mapActions({
            GetStockpoints: "partner/fetchStockpointsByTenant",
            GetItems: "item/fetchItemsByCatalog",
            GetItemStockStatus: "inventory/getItemStockStatus",
            DownloadStockStatus: "inventory/getItemStockDownload",
        }),
        async changeStockpoint(data) {
            if (data !== null) {
                this.loading = true;
                let payload = { needInventory: true };
                const stockpointParentData = await getPartnerParentData(
                    data._id,
                ).then((x) => x.response);
                if (this.userCategory === "MANUFACTURER") {
                    payload.manufacturerId =
                        this.$store.getters["auth/getUserID"];
                } else {
                    payload.provider = stockpointParentData._id;
                }
                this.stockPointId = data._id;
                this.GetItems(payload)
                    .then(() => (this.loading = false))
                    .catch(() => (this.loading = false));
            }
        },
        changeItem(data) {
            this.itemId = data._id;
            this.selectedItem = data;
        },
        getStockStatus() {
            this.loading = true;
            this.stocksData = [];
            this.GetItemStockStatus({
                id: this.selectedItem._id,
                data: { stockPointId: this.stockPointId },
            })
                .then((res) => {
                    this.loading = false;
                    if (res.inventoryStatus && res.inventoryStatus.length) {
                        let object = {
                            ["ITEM NAME"]: this.selectedItem.label,
                            ["TOTAL STOCK"]: 0,
                        };
                        res.inventoryStatus.map((Obj) => {
                            object[Obj.state] = Obj.count;
                        });
                        object["TOTAL STOCK"] =
                            (object.BOOKED || 0) +
                            (object.AVAILABLE || 0) +
                            (object.EXPIRED || 0) +
                            (object.ON_REPAIR || 0) +
                            (object.DELIVERED || 0) +
                            (object.RETURNED || 0);
                        this.stocksData.push(object);
                    } else if (res.response && res.response.length) {
                        res.response.map((x) => {
                            let object = {
                                ["ITEM NAME"]: x.name,
                                ["TOTAL STOCK"]: 0,
                                LOCKED: 0,
                                BOOKED: 0,
                                EXPIRED: 0,
                                AVAILABLE: 0,
                                DELIVERED: 0,
                                RETURNED: 0,
                            };
                            x.details.map((d) => {
                                object[d.state] = d.count;
                            });
                            object["TOTAL STOCK"] =
                                object.BOOKED + object.AVAILABLE;
                            this.stocksData.push(object);
                        });
                    }
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        downloadStock() {
            this.DownloadStockStatus(this.itemId).then((res) => {
                window.open(res.downloadUrl);
            });
        },
    },
    async mounted() {
        await this.$store.dispatch("partner/fetchAllStockPointTenant");
    },
};
</script>

<style lang="sass" scoped>
.inventory-page
  padding: 0.5rem

.inventory-card
  min-height: 400px
  border: 1px solid #dee2e6
  border-radius: 8px
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06)

// Filter Section
.filter-section
  background: #f8f9fa
  border-radius: 8px
  padding: 1rem 1.25rem
  margin-top: 1rem
  border: 1px solid #e9ecef

.filter-label
  font-size: 0.78rem
  font-weight: 600
  text-transform: uppercase
  letter-spacing: 0.04em
  color: #6c757d
  margin-bottom: 0.35rem
  display: block

.filter-select
  width: 100%

.go-btn
  height: 40px
  font-weight: 600
  letter-spacing: 0.05em
  width: 100%

  // @media (min-width: 768px)
    // margin-top: 1.75rem

// Table
.inventory-table
  font-size: 0.875rem

  th
    background-color: #3c4b64 !important
    color: #fff !important
    font-weight: 600
    font-size: 0.8rem
    text-transform: uppercase
    letter-spacing: 0.04em
    white-space: nowrap
    padding: 0.65rem 0.75rem

  td
    vertical-align: middle
    padding: 0.55rem 0.75rem

  .col-item-name
    min-width: 160px

// Mobile Cards
.mobile-stock-card
  border-radius: 8px
  border: 1px solid #e0e0e0
  overflow: hidden
  box-shadow: 0 1px 4px rgba(0,0,0,0.07)

.mobile-card-header
  background: #3c4b64
  color: #fff
  padding: 0.65rem 1rem
  font-weight: 600
  font-size: 0.9rem

.mobile-card-body
  padding: 0.5rem 0

.stat-row
  display: flex
  justify-content: space-between
  align-items: center
  padding: 0.45rem 1rem
  border-bottom: 1px solid #f0f0f0

  &:last-child
    border-bottom: none

.stat-label
  font-size: 0.82rem
  color: #6c757d
  font-weight: 500

.stat-value
  font-weight: 700
  font-size: 0.92rem
  border-radius: 12px
  padding: 0.1rem 0.65rem

  &.total
    background: #e8f0fe
    color: #1a56db

  &.available
    background: #e6f9f0
    color: #0d7a4e

  &.booked
    background: #fff4e5
    color: #c07a00

  &.delivered
    background: #eef2ff
    color: #4c51bf

  &.returned
    background: #f3f4f6
    color: #374151

  &.expired
    background: #fef2f2
    color: #b91c1c

// Bottom bar
.bottom-bar
  display: flex
  align-items: center
  flex-wrap: wrap
  gap: 0.75rem

  @media (max-width: 575px)
    flex-direction: column
    align-items: stretch

    .ml-auto
      margin-left: 0 !important

.download-btn
  font-weight: 600
  padding: 0.45rem 1.25rem
  width: 100%

  @media (min-width: 576px)
    width: auto

// Empty State
.empty-state
  text-align: center
  padding: 3rem 1rem
  color: #adb5bd

.empty-icon
  font-size: 3rem
  margin-bottom: 0.75rem

.empty-text
  font-size: 0.95rem
  color: #6c757d

// Responsive table wrapper ensures horizontal scroll on small screens
.table-responsive
  overflow-x: auto
  -webkit-overflow-scrolling: touch
</style>
